<template>
	<div>
		<div class="row slim-grid-row mb-2 pb-2 border-light-bottom">
			<template v-if="data.type == 'kilo'">
				<div class="col-8 align-self-center">
					<p class="mb-0 body-2 font-bold text-black text-truncate">
						{{data.service.name}}
					</p>
					<p v-if="data.notes != ''" class="mb-0 body-3-3 text-truncate" style="line-height: 1 !important;">Note : {{data.notes}}</p>
				</div>
				<div class="col-4 text-right">
					<p class="mb-0 body-2 text-green font-bold text-12 cursor-pointer d-inline-block align-middle mr-2" @click="toggleNote">Add Note</p>
					<p class="mb-0 body-2 text-orange font-bold text-12 cursor-pointer d-inline-block align-middle" @click="removeKiloService">{{$t('hotel.action.cancel')}}</p>
				</div>
			</template>
			<template v-else>
				<div class="col-12">
					<p class="mb-2 body-2 font-bold text-black text-truncate">
						{{data.service.name}}
					</p>
				</div>
				<template v-for="(product,index) in data.product">
					<div class="col-7 mb-3">
						<div class="pl-3 pb-3" :class="{'border-bottom':(index+1)!=data.product.length}">
							<p class="mb-0 body-2 font-bold text-black text-truncate">{{product.data.name}}</p>
							<p class="mb-0 body-3-3 font-semibold text-truncate">{{product.data.category.name}}</p>
							<div class="w-100" style="margin-top:-5px !important;">
								<p class="mb-0 body-3-3 text-truncate d-inline-block font-semibold align-middle text-orange mr-1">[{{product.qty}}x]</p>
			        	<p class="mb-0 body-3-3 text-truncate d-inline-block font-semibold align-middle">{{ formatCurrency(product.data.price)}}</p>
							</div>
			        <p v-if="product.notes != ''" class="mb-0 body-3-3 text-truncate">Note : {{product.notes}}</p>
						</div>
					</div>
					<div class="align-self-center col-5 mb-2">
            <div class="row">
              <div class="col-4">
                <div class="pr-1">
                  <div class="rounded-4 py-1 box-shadow-cart w-100 bg-orange text-center cursor-pointer" @click="toggleNote(index)">
                    <img src="../../../../assets/img/icon/edit-white.png" width="14" style="margin-top:-5px !important">
                  </div>
                </div>
              </div>
              <div class="col-8">
        				<div class="row rounded-4 py-1 box-shadow-cart text-right w-100 no-gutters">
    	            <div class="col-4 text-center cursor-pointer" @click="changeQtyProduct('minus',index)">
    	            	<svg width="12" height="4" viewBox="0 0 12 4" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path class="fill-primary" d="M11.8334 2.57332C11.8334 2.84947 11.6096 3.07332 11.3334 3.07332H0.666748C0.390606 3.07332 0.166748 2.84947 0.166748 2.57332V1.23999C0.166748 0.963848 0.390606 0.73999 0.666748 0.73999H11.3334C11.6096 0.73999 11.8334 0.963848 11.8334 1.23999V2.57332Z" fill="#26B11D"/>
										</svg>
    	              <!-- <img src="../../../../assets/img/icon/minus-orange.png" width="14"> -->
    	            </div>
    	            <div class="col-4 text-center">
    	              <p class="mb-0 body-2-4 position-relative" style="top: 3px;">{{product.qty}}</p>
    	            </div>
    	            <div class="col-4 text-center cursor-pointer" @click="changeQtyProduct('plus',index)">
    	            	<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path class="fill-primary" d="M14 8.40662C14 8.68276 13.7761 8.90662 13.5 8.90662H8.5C8.22386 8.90662 8 9.13047 8 9.40662V14.4066C8 14.6828 7.77614 14.9066 7.5 14.9066H6.5C6.22386 14.9066 6 14.6828 6 14.4066V9.40662C6 9.13047 5.77614 8.90662 5.5 8.90662H0.5C0.223857 8.90662 0 8.68276 0 8.40662V7.40662C0 7.13047 0.223858 6.90662 0.5 6.90662H5.5C5.77614 6.90662 6 6.68276 6 6.40662V1.40662C6 1.13047 6.22386 0.906616 6.5 0.906616H7.5C7.77614 0.906616 8 1.13047 8 1.40662V6.40662C8 6.68276 8.22386 6.90662 8.5 6.90662H13.5C13.7761 6.90662 14 7.13047 14 7.40662V8.40662Z" fill="#26B11D"/>
										</svg>
    	              <!-- <img src="../../../../assets/img/icon/plus-orange.png" width="14"> -->
    	            </div>
    	          </div>
              </div>
            </div>
    			</div>
				</template>
			</template>
		</div>


		<!-- Product Note -->
    <PopupInputNote 
      v-if="is_note" 
      :title="note_title"
      :data="note_data"
      @cancel="toggleNote" 
      @submit="submitNote"></PopupInputNote>
	</div>
</template>
<script>
	import {mapGetters,mapMutations} from 'vuex';
	import {formatCurrency} from '@/utils/index.js'
	import PopupInputNote from '@/components/hotel/concierge/general/PopupInputNote'
	export default{
		props:['data'],
		components:{
			PopupInputNote
		},
		data(){
			return{
				is_note: false,
        note_title: '',
        note_data: '',
        product_index_selected: null
			}
		},
		methods:{
			...mapGetters(['getConciergeOrder']),
      ...mapMutations(['setConciergeOrderCustomLaundry','resetConciergeOrder','setConciergeOrderCustomModule']),
      formatCurrency(value){
        return formatCurrency(value);
      },
      removeKiloService(){
      	let params = {
          type: 'kilo',
          service: this.data.service,
          product: []
        }
        this.setConciergeOrderCustomLaundry(params)
        this.setConciergeOrderCustomModule('laundry')
      },
      toggleNote(product_index=null){
        this.is_note = !this.is_note
      	this.product_index_selected = product_index
        if(this.is_note){
          this.note_title = this.data.type == 'kilo' ? this.data.service.name : this.data.product[product_index].data.name
          this.note_data =  this.data.type == 'kilo' ? this.data.notes : this.data.product[product_index].notes
        }else{
          this.note_title = ''
          this.note_data = ''
        }
      },
      submitNote(notes){
        this.note_data = notes
        let params  = {
        	type: this.data.type,
        	service: this.data.service,
        	product: {}, 
        	notes: this.note_data
        }
        if(this.data.type == 'kilo'){
        	params.action = 'update_notes'
        }else{
        	params.product = this.data.product[this.product_index_selected].data
        	params.qty = this.data.product[this.product_index_selected].qty
        }

        this.setConciergeOrderCustomLaundry(params)
        this.setConciergeOrderCustomModule('laundry')
        this.toggleNote()
      },
      changeQtyProduct(type,index){
        let params = {
          type: 'pcs',
          service: this.data.service,
          product: this.data.product[index].data,
          qty: type == 'plus' ? this.data.product[index].qty+1:this.data.product[index].qty-1,
          notes: this.data.product[index].notes
        }
        if(type == 'plus' || (type == 'minus' && this.data.product[index].qty > 0)){
          this.setConciergeOrderCustomLaundry(params)
          this.setConciergeOrderCustomModule('laundry')
        }else{
          console.log("UNKNOW FUNCTION")
        }
      },
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/concierge/general/menuCartLaundry.vue